export default __webpack_public_path__ + "static/careers-slide-4-f478ff14ce4c443392e32acee7b4bc35.png";